import { ReactComponent as FlagIcon } from "./svg/fl-flag.svg";
import "../flag-icon.scss";

export const FLFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
